import React from 'react';
import { Container } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import ReportTable from './components/Reports'


const ReportTableList = (props) => (

    <Container>
        <ReportTable {...props} />
    </Container>
);

ReportTableList.propTypes = {
    t: PropTypes.func.isRequired,
};

export default withTranslation('common')(ReportTableList);

